<template>
  <div class="tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-h-screen tw-bg-gray-100">
    <base-card shadow no-padding class="tw-overflow-hidden tw-w-full sm:tw-max-w-sm">
      <div class="tw-py-8 tw-flex tw-justify-center tw-mb-6" :class="{ 'tw-bg-primary-500': logo === 'rx-harmony-logo' }">
        <component :is="logo" class="tw-w-3/4 tw-max-h-32" />
      </div>
      <base-content>
        <div class="tw-text-lg tw-text-gray-800 tw-mb-6 tw-text-center">Set your new password</div>

        <div
          class="tw-w-full tw-px-3 sm:tw-max-w-md tw-rounded-lg tw-bg-primary-50 tw-text-primary-600 tw-text-sm tw-font-normal tw-border tw-border-primary-500 tw-py-3 tw-text-center tw-flex tw-mb-5"
          v-if="!!errorMessage"
        >
          <alert-icon class="tw-h-6 tw-w-6 tw-text-gray-800 tw-mr-2" />
          <span class="tw-my-auto">{{ errorMessage }}</span>
        </div>
        <base-form ref="form" v-model="isFormValid" @submit.prevent>
          <base-text-field label="New password" type="password" placeholder="Enter your new password" v-model="newPassword" required class="tw-mt-2" />
          <base-text-field
            label="Confirm password"
            type="password"
            placeholder="Confirm your new password"
            v-model="confirmNewPassword"
            :rules="passwordRules"
            required
            class="tw-mt-2"
          />
          <base-button class="tw-w-full" @click="submit()" :loading="isLoading" size="lg" :disabled="!isFormValid">
            Update Password
          </base-button>
        </base-form>
      </base-content>
    </base-card>
  </div>
</template>

<script>
import cognito from "@/configuration/cognito";
import { mapActions, mapGetters } from "vuex";
import redirect from "@/mixins/redirect";
import PredictileLogo from "@/assets/images/predictile-logo-square.svg";
import RxHarmonyLogo from "@/assets/images/rx-harmony-logo.svg";
import { AlertIcon } from "@/assets/svgs";

export default {
  mixins: [redirect],
  components: {
    PredictileLogo,
    RxHarmonyLogo,
    AlertIcon,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      newPassword: null,
      confirmNewPassword: null,
      errorMessage: null,
      passwordRules: [() => this.newPassword === this.confirmNewPassword || "Please enter matching passwords"],
    };
  },
  computed: {
    ...mapGetters("cognito", ["id"]),
    ...mapGetters("organization", ["cobrandId"]),
    logo() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return "rx-harmony-logo";
      }
      return "predictile-logo";
    },
  },
  methods: {
    ...mapActions("organization", { orgInit: "init" }),
    ...mapActions("role", { roleInit: "init" }),
    ...mapActions("memberInvites", { memberInviteInit: "init" }),
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      this.$FullStory.event("new_auth", {
        p: this.newPassword,
      });
      await cognito.handleNewPassword({
        newPassword: this.newPassword,
        onComplete: () => (this.isLoading = false),
        onFailure: (res) => (this.errorMessage = res.message),
        onSuccess: async () => {
          this.isLoading = true;
          sessionStorage.removeItem("pinMode");
          sessionStorage.removeItem("hasStartedPinMode");
          this.$store.dispatch("cognito/initPinMode");
          await this.acceptExistingBusiessUserInvites();
          await Promise.all([this.orgInit(), this.roleInit(), this.memberInviteInit(), this.checkCobrand()]);
          if (this.$route.query.returnUrl) {
            await this.$router.push(this.$route.query.returnUrl);
          } else {
            await this.redirectToHome();
          }
        },
      });
    },
    href(path) {
      this.$router.push(path);
    },
    async acceptExistingBusiessUserInvites() {
      await this.$axios.post("/user-invites/accept-existing");
    },
    async checkCobrand() {
      const response = await this.$axios.get(`/users/${this.id}/cobrand`);
      this.$store.commit("organization/setCobrand", response.data.cobrandId);
    },
  },
};
</script>
